// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';

// Components
import BlogPostContent from '../blogPostContent/blogPostContent';
import BlogPostImages from '../blogPostImages/blogPostImages';
import BlogPostQuote from '../blogPostQuote/blogPostQuote';
import BlogPostImageQuote from '../blogPostImageQuote/blogPostImageQuote';

// Styles
import BlogPostFlexibleContentStyles from './blogPostFlexibleContentFactory.styles';

const layoutMap = {
  Content: BlogPostContent,
  Images: BlogPostImages,
  Quote: BlogPostQuote,
  ImageQuote: BlogPostImageQuote,
};

export default function BlogFlexibleContentFactory({ layouts }) {
  const layoutRenderer = ({ layout }) => {
    if (!layout || !layout?.fieldGroupName) return null;

    const options = {
      name: layout?.fieldGroupName,
      key: uuid(),
    };

    // Convert layout name from GraphQL to component name
    options.name = options.name.replace(
      'Post_Blogflexiblecontent_FlexibleContent_',
      '',
    );

    // Retrieve layout from the component map
    const Component = layoutMap[options.name];

    return (
      <div key={options.key} className="flexible-content-layout">
        <Component layout={layout} />
      </div>
    );
  };

  return (
    <BlogPostFlexibleContentStyles itemScope>
      <article itemProp="articleBody" className="article-body">
        {layouts?.length &&
          layouts.map((layout, index) => layoutRenderer({ layout, index }))}
      </article>
    </BlogPostFlexibleContentStyles>
  );
}

BlogFlexibleContentFactory.propTypes = {
  layouts: PropTypes.arrayOf(
    PropTypes.shape({
      fieldGroupName: PropTypes.string,
    }),
  ),
  pageDisplayOptions: PropTypes.shape({
    displayTitle: PropTypes.bool,
  }),
};

BlogFlexibleContentFactory.defaultProps = {
  layouts: [],
  pageDisplayOptions: {},
};
